/**
 * DamageDirection — Shows a red arc indicator at screen edge pointing
 * to the direction damage came from.
 *
 * Fades out over 1.5 seconds. Multiple simultaneous indicators supported.
 */

export class DamageDirection {
  constructor() {
    this._container = document.createElement('div');
    this._container.style.cssText = `
      position: fixed; top: 0; left: 0; width: 100%; height: 100%;
      pointer-events: none; z-index: 160;
    `;
    document.body.appendChild(this._container);
    this._indicators = [];
  }

  /**
   * Show damage indicator.
   * @param {THREE.Vector3} sourcePos - world position of damage source
   * @param {THREE.Vector3} playerPos - world position of player
   * @param {number} playerYaw - player look direction (radians)
   */
  show(sourcePos, playerPos, playerYaw) {
    // Calculate angle from player to source (in player's frame)
    const dx = sourcePos.x - playerPos.x;
    const dz = sourcePos.z - playerPos.z;
    const worldAngle = Math.atan2(dx, -dz); // -dz because Three.js forward is -Z
    const relativeAngle = worldAngle - playerYaw;

    // Normalize to -PI..PI
    let angle = relativeAngle;
    while (angle > Math.PI) angle -= 2 * Math.PI;
    while (angle < -Math.PI) angle += 2 * Math.PI;

    // Create indicator element
    const el = document.createElement('div');
    el.style.cssText = `
      position: absolute;
      top: 50%; left: 50%;
      width: 400px; height: 400px;
      transform: translate(-50%, -50%) rotate(${angle}rad);
      pointer-events: none;
      opacity: 0.8;
    `;

    // Red arc pointing "up" (away from player) after rotation
    el.innerHTML = `
      <svg viewBox="-200 -200 400 400" style="width:100%;height:100%;">
        <path d="M -60 -180 Q 0 -220 60 -180 L 20 -160 Q 0 -170 -20 -160 Z"
              fill="rgba(255,50,50,0.75)"
              stroke="rgba(255,100,100,0.9)" stroke-width="2"/>
      </svg>
    `;

    this._container.appendChild(el);
    const entry = { el, life: 1.5, maxLife: 1.5 };
    this._indicators.push(entry);
  }

  update(dt) {
    for (let i = this._indicators.length - 1; i >= 0; i--) {
      const e = this._indicators[i];
      e.life -= dt;
      if (e.life <= 0) {
        e.el.remove();
        this._indicators.splice(i, 1);
      } else {
        e.el.style.opacity = (e.life / e.maxLife) * 0.8;
      }
    }
  }
}
